export function formatTaxRatePercent(rate: number | null | undefined): string {
  const decimalRate = Number(rate);
  const percent = Number.isFinite(decimalRate) ? Math.max(0, decimalRate) * 100 : 0;

  return `(${new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(percent)}%)`;
}
